"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Icon_meta_1 = require("../Icon.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('span', Icon_meta_1.ICON_CATEGORY_KEY, Icon_meta_1.ICON_COMPONENT_KEY, ['wrapper']);